import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';
import { useSelector } from 'react-redux';
import { hasPermissionsFor } from 'helpers/_helpers';
import { DRAWER_TYPES } from 'pages/ScheduleV6/constants/constants';
import { useScheduleActions } from 'pages/ScheduleV6/components/hooks/useScheduleActions';
import FilterIcon from 'assets/images/filter-icon.svg';
import AddIcon from 'assets/images/add-in-square.svg';
import CustomMenu from 'components/CustomMenu/CustomMenu';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const Header = ({
  classes,
  openDrawer,
  showPublishModal,
  showUpdateModal,
  canPublish,
  canUpdate,
  showReconcileModal,
  hasEditAccess,
}) => {
  const showAllLocations = useSelector((store) => store.schedule.showAllLocations);

  const hasSchedulePermission = hasPermissionsFor('scheduleFullAccess');
  const displayAddNote = hasPermissionsFor('notesRead') || hasPermissionsFor('notesFullAccess');

  const { hasUnreconciledSheets } = useScheduleActions();

  const addOptions = useMemo(() => {
    const options = [
      {
        value: 'addSheet',
        onClick: openDrawer(DRAWER_TYPES.addWorklog),
        label: <span className={classes.addOption}>+ Add Worklog</span>,
      },
    ];

    if (displayAddNote) {
      options.push({
        value: 'addNote',
        onClick: openDrawer(DRAWER_TYPES.addNote),
        label: <span className={classes.addOption}>+ Add Note</span>,
      });
    }

    return options;
  }, [openDrawer, displayAddNote, classes.addOption]);

  return (
    <div style={{ margin: '10px 15px' }}>
      <Grid container justifyContent="space-between" alignItems="center">
        {showAllLocations ? (
          <span style={{ width: 210 }} />
        ) : (
          <div className={classes.publishGroup}>
            {hasSchedulePermission ? (
              <>
              <Button
                id="manageButtons"
                variant="contained"
                color="secondary"
                onClick={showPublishModal}
                disableTouchRipple
                disabled={!hasEditAccess || !canPublish}
              >
                Publish
              </Button>
              <Button
                id="manageButtons"
                variant="contained"
                color="secondary"
                className={classnames(canUpdate ? classes.red : null)}
                onClick={showUpdateModal}
                disableTouchRipple
                disabled={!hasEditAccess || !canUpdate}
              >
                Update
              </Button>
            </>
            ) : null}
            {hasUnreconciledSheets && hasSchedulePermission && (
              <Button
                variant="contained"
                color="secondary"
                className={classes.reconcileBtn}
                onClick={showReconcileModal}
                disabled={!hasEditAccess}
                disableTouchRipple
              >
                Reconcile
              </Button>
            )}
          </div>
        )}

        <div className={classnames(classes.iconButtonGroup)}>
          <CustomMenu MenuProps={{ className: classes.addButton }} options={addOptions}>
            {({ handleButtonClick, open }) => (
              <Button
                variant="text"
                className={classes.iconButton}
                onClick={handleButtonClick}
                disableRipple
                endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                disabled={!hasEditAccess}
              >
                <img src={AddIcon} alt="add" />
              </Button>
            )}
          </CustomMenu>
          <Button
            variant="text"
            className={classes.iconButton}
            onClick={openDrawer(DRAWER_TYPES.filters)}
            disableTouchRipple
          >
            <img src={FilterIcon} alt="filter" />
          </Button>
        </div>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(Header);
